import React, { Component } from 'react';
import Slider from 'react-slick';
import arrowIcon from '../images/arrow.svg';

function Arrow(props) {
  const { className, style, onClick } = props;
  let isNext = !!className.match('next');
  return (
    <div
      className={`${className} ModalCarousel__arrow clicked__newsroom_power__${isNext ? 'next' : 'previous'}`}
      style={{...style}}
      onClick={onClick}>
      <img src={arrowIcon} alt="Carousel Arrow" />
    </div>
  )
}

export default class ModalCarousel extends Component {
  render() {
    if (!this.props.showModal) {
      document.body.style.overflow = '';
      return null;
    } else {
      document.body.style.overflow = 'hidden';
    }
    var settings = {
      ...this.props.sliderSettings,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      nextArrow: <Arrow />,
      prevArrow: <Arrow />,
      initialSlide: this.props.slide
    };
    return (
      <div className="ModalCarousel">
        <div className="ModalCarousel__upper-right">
          <button className="ModalCarousel__CloseButton clicked__newsroom_power__close-modal" onClick={this.props.close}>&lt; Back to Guide</button>
        </div>
        <Slider {...settings}>
          {this.props.children && this.props.children.map((c, i) => <div key={i} className="ModalCarousel__slide">{c}</div>)}
        </Slider>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/lib/ModalCarousel.js